import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './device-reported-metric.reducer';

export const DeviceReportedMetricDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const deviceReportedMetricEntity = useAppSelector(state => state.deviceReportedMetric.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="deviceReportedMetricDetailsHeading">
          <Translate contentKey="rainspotApp.deviceReportedMetric.detail.title">DeviceReportedMetric</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{deviceReportedMetricEntity.id}</dd>
          <dt>
            <span id="attribute">
              <Translate contentKey="rainspotApp.deviceReportedMetric.attribute">Attribute</Translate>
            </span>
          </dt>
          <dd>{deviceReportedMetricEntity.attribute}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="rainspotApp.deviceReportedMetric.value">Value</Translate>
            </span>
          </dt>
          <dd>{deviceReportedMetricEntity.value}</dd>
          <dt>
            <span id="deviceReportedTime">
              <Translate contentKey="rainspotApp.deviceReportedMetric.deviceReportedTime">Device Reported Time</Translate>
            </span>
          </dt>
          <dd>
            {deviceReportedMetricEntity.deviceReportedTime ? (
              <TextFormat value={deviceReportedMetricEntity.deviceReportedTime} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="rainspotApp.deviceReportedMetric.device">Device</Translate>
          </dt>
          <dd>{deviceReportedMetricEntity.device ? deviceReportedMetricEntity.device.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/device-reported-metric" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/device-reported-metric/${deviceReportedMetricEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DeviceReportedMetricDetail;
